<template>
  <DBox
    :id="'cmp-catalog-tracks-sidewindow-manual_matches'"
    :addButton="false"
    :addLink="false"
  >
    <NTable
      id="catalog-tracks-sidewindow-manual_matches-list"
      class="h1 dbox1"
      :config="tableConfig"
      :headers="headers"
      :items="list"
      :showNoItems="true"
    >
      <template v-slot:item="{ item, tdcon }">
        <tr>
          <td v-bind="tdcon('account_name')">
            <span class="txtov" :title="item['account_name']">
              {{ item["account_name"] }}
            </span>
          </td>
          <td v-bind="tdcon('text02')">
            <span class="txtov" :title="item['text02']">
              {{ item["text02"] }}
            </span>
          </td>
          <td v-bind="tdcon('option')">
            <div class="dt-icon-container">
              <img
                @click.stop="e => onDeleteManualMatches(item)"
                src="static/icons/delete.svg"
                class="dt-icon v5 s1 ut-center"
              />
            </div>
          </td>
        </tr>
      </template>
    </NTable>
  </DBox>
</template>

<script>
import DBox from "@dtplugins/dbox/dbox";
import NTable from "@/plugins/datatable/datatable";
import {
  createNTableConfig,
  createTableHeader
} from "../../../../plugins/datatable";
import { confirmDelete } from "../../../../dt-plugins/confirmation/confirmation-common";

export default {
  components: {
    DBox,
    NTable
  },
  props: ["selectedTrackDetails"],
  computed: {
    tableConfig: function() {
      return createNTableConfig({
        headerStyle: 3,
        fullHeight: true
      });
    },
    list: function() {
      return this.selectedTrackDetails.manual_matches || [];
    },
    headers: function() {
      return [
        createTableHeader("account_name", { f: 0.7 }),
        createTableHeader("text02", { text: "Identifier" }),
        createTableHeader("option", { text: false, mw: 30 })
      ];
    }
  },
  methods: {
    onDeleteManualMatches: async function(item) {
      const confirmationResult = await confirmDelete(
        "account name",
        item.account_name
      );
      if (confirmationResult === "OK") {
        this.$emit("deleted", item);
      }
    }
  }
};
</script>
